import { fetchLayerDetails } from '@app/services/legendService'
import { useQuery } from '@tanstack/react-query'

export const useLayerDetail = (id: string | undefined) => {
  return useQuery({
    queryKey: ['layer-detail', id],
    queryFn: () => fetchLayerDetails(id!),
    enabled: !!id,
  })
}
